





































import { Component, Vue } from 'vue-property-decorator';
import {
  deleteConversionApiClientInfo,
  getConversionApiClientInfo,
  putConversionApiClientInfo,
} from '@/appsync/lambda/conversionApiService';
import WarningOnAccessFromIosDialog from '@/components/organisms/WarningOnAccessFromIosDialog.vue';
import { refreshStores } from '@/containers/globals/globalSharedService';
import ErrorMessagePageTemplate from '@/containers/templates/ErrorMessagePageTemplate.vue';
import WebApiSettingBody from '@/containers/templates/WebApiSettingBody.vue';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import { ConversionApiClientInfo, LoginInfo, UserInfo } from '@/types/type';
import {
  getDisabledRoutes,
  isAccessedFromIosDeviceOrSafariBrowser,
} from '@/utils/CommonUtils';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

@Component({
  components: {
    WebApiSettingBody,
    ErrorMessagePageTemplate,
    WarningOnAccessFromIosDialog,
  },
})
export default class WebApiSetting extends Vue {
  private loading: boolean = true;
  private isSaved: boolean = false;
  private isDeleted: boolean = false;

  private clientId: string = '';
  private clientSecret: string = '';

  private clientInfoExists: boolean = false;

  private isCommonsettingWebApiPageEnabled: boolean = false;

  private notEnabledImgAltMessage: String = 'Page Not Enabled';

  private notEnabledImgName: String = 'page-not-enabled';

  private notEnabledImgWidth: String = '250px';

  private notEnabledImgHeight: String = '186px';

  private showAccessFromIosOrSafariWarningDialog: boolean = false;

  public async created(): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    await refreshStores(loginInfo);

    const disabledRoutes = await getDisabledRoutes(
      this.loginInfo.tenant,
      this.loginInfo.landscape,
      this.loginInfo.loginName
    );

    if (!disabledRoutes.includes(PAGE_PATH_BY_NAME.commonsettingWebApi)) {
      this.isCommonsettingWebApiPageEnabled = true;
      const isAccessedFromNotRecommendedEnv: boolean = isAccessedFromIosDeviceOrSafariBrowser();
      if (isAccessedFromNotRecommendedEnv) {
        this.showAccessFromIosOrSafariWarningDialog = true;
      }
      const data = await getConversionApiClientInfo(
        loginInfo.tenant,
        loginInfo.landscape
      );
      if (data) {
        this.clientId = data.clientId;
        this.clientSecret = 'client secret placeholder';
        this.clientInfoExists = true;
      }
    }
    this.loading = false;
  }

  private get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  private get loginInfo(): LoginInfo {
    return commonModule.loginInfo;
  }

  private async createConversionApiClientInfo({
    clientId,
    clientSecret,
  }: ConversionApiClientInfo) {
    await putConversionApiClientInfo(
      this.loginInfo.tenant,
      this.loginInfo.landscape,
      clientId,
      clientSecret
    );
    this.isSaved = true;
    this.clientId = clientId;
    this.clientSecret = clientSecret;
    this.clientInfoExists = true;
  }

  private async deleteConversionApiClientInfo() {
    await deleteConversionApiClientInfo(
      this.loginInfo.tenant,
      this.loginInfo.landscape
    );
    this.isDeleted = true;
    this.clientId = '';
    this.clientSecret = '';
    this.clientInfoExists = false;
  }
}
